// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SxrvNgREHSYhP4jCZE7a {
  min-height: 500px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.glbL3tSHbPsVqHFTbhQR {
  flex: 1;
  overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/Header/Simulation/Workbook/SimSeqCompinent/styles.module.less"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAAF;AAGA;EACE,OAAA;EACA,kBAAA;AADF","sourcesContent":["\n.container {\n  min-height: 500px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.content {\n  flex: 1;\n  overflow-y: scroll;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SxrvNgREHSYhP4jCZE7a`,
	"content": `glbL3tSHbPsVqHFTbhQR`
};
export default ___CSS_LOADER_EXPORT___;
